module.exports = __webpack_public_path__ + "img/globalicon.ac6871ce.png";